"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.murmur = void 0;
const hash_1 = __importDefault(require("@emotion/hash"));
function murmur(s) {
    return (0, hash_1.default)(s);
}
exports.murmur = murmur;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXVybXVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL211cm11ci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSx5REFBaUM7QUFFakMsU0FBZ0IsTUFBTSxDQUFDLENBQVM7SUFDOUIsT0FBTyxJQUFBLGNBQUksRUFBQyxDQUFDLENBQUMsQ0FBQztBQUNqQixDQUFDO0FBRkQsd0JBRUMifQ==